<template>
  <div class="custom-margin-full-page">
    <v-data-table
        align="center"
        :headers="headers"
        :items="notifications.data"
        :items-per-page="20"
        disable-sort
        hide-default-footer>
      <template
          v-slot:[`item.title`]="{ item }">
        <div v-if="item.title" :style="'border-style:solid;border-color:'+item.color+';border-radius:10px' ">
          {{ item.title }}
        </div>
      </template>
      <template
          v-slot:[`item.content`]="{ item }">
        <div v-if="item.content">
          <div v-if="item.content.length > 20">
            {{ item.content.slice(0, 20) }} ...
          </div>
          <div v-else>
            {{ item.content }}
          </div>
        </div>
      </template>
      <template
          v-slot:[`item.priority`]="{ item }">
        <div v-if="item.priority === 'low'">
          کم
        </div>
        <div v-else-if="item.priority === 'normal'">
          متوسط
        </div>
        <div v-else>
          بالا
        </div>
      </template>
      <template
          v-slot:[`item.section`]="{ item }">
        <div v-if="item.section === 'concert'">
          کنسرت
        </div>
        <div v-if="item.section === 'change_program'">
          تغییر در برنامه ها
        </div>
        <div v-if="item.section === 'news'">
          اخبار
        </div>
        <div v-if="item.section === 'offer'">
          پیشنهادات
        </div>
        <div v-if="item.section === 'general'">
          عمومی
        </div>
      </template>

      <template
          v-slot:[`item.has_attachment`]="{ item }">
        <div v-if="item.has_attachment">
          <v-icon color="success">mdi-check</v-icon>
        </div>
        <div v-else>
          <v-icon color="error">mdi-close</v-icon>
        </div>
      </template>

      <template
          v-slot:[`item.attachment_type`]="{ item }">
        <div v-if="item.attachment_type === 'audio'">
          صوتی
        </div>
        <div v-if="item.attachment_type === 'video'">
          ویدیو
        </div>
        <div v-if="item.attachment_type === 'pdf'">
          پی دی اف
        </div>
        <div v-if="item.attachment_type === 'image'">
          تصویر
        </div>
        <div v-if="item.attachment_type === 'zip'">
          فایل فشرده
        </div>
      </template>

      <template
          v-slot:[`item.url`]="{ item }">
        <div v-if="item.url">
          <v-btn fab color="primary" @click="openLink(item.url)">
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </div>
      </template>
      <template
          v-slot:[`item.operation`]="{ item }">
        <v-icon class="mx-1" color="primary" @click="show(item.id)">mdi-eye</v-icon>
      </template>
    </v-data-table>
    <v-row>
      <v-col cols="12">
        <v-pagination
            class="text-center"
            color="#1ab69d"
            v-model="notifications.current_page"
            :length="notifications.last_page"
            circle
            @input="getNotifications"
        ></v-pagination>
      </v-col>
    </v-row>

    <v-dialog v-if="notification" v-model="showSingleNotificationDialog" max-width="50vw">
      <v-card class="ma-0">
        <v-row class="px-2 ma-0">
          <v-col cols="12">
            {{ notification.title }}
          </v-col>
          <v-col cols="12" v-if="notification.content">
            {{ notification.content }}
          </v-col>
          <v-col cols="12" v-if="notification.attachment_type === 'image'">
            <img style="width: 100%; height: 100%; object-fit: contain;" :src="notification.url"
                 :alt="notification.title">
          </v-col>
          <v-col cols="12" v-if="notification.attachment_type === 'video'">
            <video width="100%" controls :src="notification.url" :alt="notification.title">
            </video>
          </v-col>
          <v-col cols="12">
            <div style="font-size:11px" v-if="notification.created_at_fa">
              ارسال شده در {{ notification.created_at_fa }} <br>
            </div>
            <div style="font-size:11px" v-if="notification.seen_at_fa">
              دیده شده در {{ notification.seen_at_fa }} <br>
            </div>
          </v-col>
          <v-col :cols="notification.url && !notification.attachment_type ? 6 : 12" class="text-center">
            <v-btn style="letter-spacing: normal" color="error" @click="showSingleNotificationDialog = false">
              بستن
            </v-btn>
          </v-col>
          <v-col
              v-if="notification.url && !notification.attachment_type"
              cols="6" class="text-center">
            <v-btn style="letter-spacing: normal" color="#1ab69d" class="white--text" @click="redirectToNotification()">
              مشاهده
            </v-btn>
          </v-col>

        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "NotificationsDesktop",
  data() {
    return {
      showSingleNotificationDialog: false,
      notifications: {
        current_page: 1
      },
      notification: null,
      headers: [
        // {text: 'شناسه', value: 'id', align: 'center'},
        {text: 'عنوان', value: 'title', align: 'center'},
        {text: 'محتوا', value: 'content', align: 'center'},
        {text: 'نام مربی', value: 'instructor_name', align: 'center'},
        // {text: 'نام مدیر', value: 'admin_name', align: 'center'},
        // {text: 'ضرورت', value: 'priority', align: 'center'},
        // {text: 'بخش', value: 'section', align: 'center'},
        // {text: 'دارای ضمیمه', value: 'has_attachment', align: 'center'},
        // {text: 'نوع ضمیمه', value: 'attachment_type', align: 'center'},
        // {text: 'لینک', value: 'url', align: 'center'},
        {text: 'ارسال شده در', value: 'created_at_fa', align: 'center'},
        {text: 'دیده شده در', value: 'seen_at_fa', align: 'center'},
        {text: 'مشاهده', value: 'operation', align: 'center'},
      ],
    }
  },
  methods: {
    openLink(url) {
      window.open(
          url, "_blank");
    },
    getNotifications() {
      let url = 'student/notification/index/all?page=' + this.notifications.current_page ?? 1
      window.axios.get(url).then((res) => {
        this.notifications = res.data.data
      })
    },
    show(id) {
      window.axios.get('student/notification/get/' + id).then((res) => {
        this.notification = res.data.data
        this.showSingleNotificationDialog = true
        this.getNotifications()
      })
    },
    redirectToNotification() {
      this.showSingleNotificationDialog = false
      console.log(this.notification)
      this.$router.push(this.notification.url)
    },
  },
  mounted() {
    this.getNotifications()
  }
}
</script>

<style scoped>
.custom-margin-full-page {
  margin: 0 10vw 0 10vw;
}
</style>